import { audioCollector } from './audio';
import { canvasCollector } from './canvas';
import { cssMediaCollector } from './css-media';
import { fontsCollector } from './fonts';
import { hardwareCollector } from './hardware';
import { localeCollector } from './locale';
import { mathCollector } from './math';
import { mediaCollector } from './media';
import { miscCollector } from './misc';
import { navigatorCollector } from './navigator';
import { privacyCollector } from './privacy-signals';
import { screenCollector } from './screen';
import { storageCollector } from './storage';
import type { Collector } from './types';
import { webglCollector } from './webgl';
import { webrtcCollector } from './webrtc';

/** All collectors, in display order. */
export const COLLECTORS: readonly Collector[] = [
  navigatorCollector,
  screenCollector,
  hardwareCollector,
  localeCollector,
  canvasCollector,
  webglCollector,
  audioCollector,
  fontsCollector,
  mediaCollector,
  webrtcCollector,
  storageCollector,
  privacyCollector,
  cssMediaCollector,
  mathCollector,
  miscCollector,
];

export type { Collector, Signal, CategoryResult } from './types';
